import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { AuthProvider } from "./contexts/AuthContext"
import { RecommendationProvider } from "./contexts/RecommendationContext"
import Navbar from "./components/Navbar"
import Home from "./pages/Home"
import Onboarding from "./pages/Onboarding"
import Recommendations from "./pages/Recommendations"
import Profile from "./pages/Profile"
import ProductDetails from "./pages/ProductDetails"
import "./App.css"

function App() {
  return (
    <AuthProvider>
      <RecommendationProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/recommendations" element={<Recommendations />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/product/:productId" element={<ProductDetails />} />
              </Routes>
            </main>
          </div>
        </Router>
      </RecommendationProvider>
    </AuthProvider>
  )
}

export default App
